
import axios from '@core_utils/api/_axios';

const register = {
    namespaced: true,
    state: {
        // 서버(brands DB) 런타임 register 설정 — undefined=미조회, null=없음/실패(코드 기본값 폴백)
        remote_register_config: undefined,
        register_step: 1,
        selected_vendor: null,
        is_conflict_register: false,
        is_project_duplicated: false,
        duplicated_message: {},
        register_loading: false,
    },
    getters: {
    },
    actions: {
        setRegisterStep: ({commit}, register_step) => {
            commit('set_register_step', register_step);
        },
        setSelectedVendor: ({commit}, selected_vendor) => {
            commit('set_selected_vendor', selected_vendor);
        },
        setIsConflictRegister: ({commit}, is_conflict_register) => {
            commit('set_is_conflict_register', is_conflict_register);
        },
        setIsProjectDuplicated: ({commit}, is_project_duplicated) => {
            commit('set_is_project_duplicated', is_project_duplicated);
        },
        setDuplicatedMessage: ({commit}, duplicated_message) => {
            commit('set_duplicated_message', duplicated_message);
        },
        setRegisterLoading: ({commit}, loading) => {
            commit('set_register_loading', loading);
        },
        initiateAllData: ({commit}) => {
            commit('reset_data');
        },
        // 테넌트 register 런타임 설정 로드 (1회) — 실패 시 null 로 확정해 코드 기본값 폴백.
        // 엔드포인트 미배포(404)여도 안전 (배포 순서 무관).
        loadTenantRegisterConfig: async ({commit, state}) => {
            if (state.remote_register_config !== undefined) return;
            try {
                const res = await axios.get('/register/tenant-config');
                commit('set_remote_register_config', (res.data && res.data.register) || null);
            } catch (e) {
                commit('set_remote_register_config', null);
            }
        }
    },
    mutations: {
        set_remote_register_config(state, config) {
            state.remote_register_config = config;
        },
        set_register_step(state, register_step) {
            state.register_step = register_step;
        },
        set_selected_vendor(state, selected_vendor) {
            state.selected_vendor = selected_vendor;
        },
        set_is_conflict_register(state, is_conflict_register) {
            state.is_conflict_register = is_conflict_register;
        },
        set_is_project_duplicated(state, is_project_duplicated) {
            state.is_project_duplicated = is_project_duplicated;
        },
        set_duplicated_message(state, duplicated_message) {
            state.duplicated_message = duplicated_message;
        },
        set_register_loading(state, loading) {
            state.register_loading = loading;
        },
        reset_data(state) {
            state.register_step = 1;
            state.selected_vendor = null;
            state.is_conflict_register = false;
        }
    },
};
export default register;
